// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__18hwT","info":"PatientInfo_info__3C3ZP"};